import React from 'react';
import hpLogoImg from 'src/assets/images/Logo.svg';
import { Container } from './styles';
import useShellRootContext from 'src/contexts/ShellRoot/useShellRootContext';

interface InitialLoadingContentProps {
  onTryAgain: () => void;
}

export const InitialLoadingContent: React.FC<InitialLoadingContentProps> = ({
  onTryAgain
}) => {
  const { t } = useShellRootContext();

  const handleTryAgain = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onTryAgain();
  };

  return (
    <Container>
      <div>
        <img
          src={hpLogoImg}
          alt="HP Logo"
        />
        <h2 data-testid="loading-screen-title">
          {t(
            'loadingScreen.signInBrowser',
            'Finish signing in with your browser'
          )}
        </h2>
        <span>
          {t('loadingScreen.troubleMessage', 'Having some trouble?')}{' '}
          <a
            href="#"
            role="button"
            tabIndex={0}
            data-testid="try-again-button"
            onClick={handleTryAgain}
          >
            {t('loadingScreen.tryAgain', 'Try again')}
          </a>
        </span>
      </div>
    </Container>
  );
};
